import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionGuard = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const backendUrl =
    process.env.REACT_APP_BACKEND_URL ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? 'http://localhost:8001'
      : '');

  const publicPages = ['/assinatura', '/configuracoes', '/login'];

  useEffect(() => {
    const fallbackStatus = () => {
      const userStatus = user?.subscription_status || null;
      const expiresAt = user?.subscription_expires
        ? new Date(user.subscription_expires).getTime()
        : null;

      if (expiresAt && expiresAt < Date.now()) {
        return 'suspended';
      }
      return userStatus;
    };

    const loadStatus = async () => {
      if (!user || user?.role === 'admin') {
        setLoading(false);
        return;
      }
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${backendUrl}/api/subscriptions/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (response.ok) {
          const data = await response.json();
          setStatus(data?.access_active === false ? 'suspended' : (data?.status || null));
        } else {
          setStatus(fallbackStatus());
        }
      } catch (error) {
        setStatus(fallbackStatus());
      } finally {
        setLoading(false);
      }
    };

    loadStatus();
    const intervalId = window.setInterval(loadStatus, 60 * 1000);
    const handleFocus = () => loadStatus();
    window.addEventListener('focus', handleFocus);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
    };
  }, [backendUrl, user]);

  if (publicPages.some((page) => location.pathname.startsWith(page))) {
    return children;
  }

  if (user?.role === 'admin') {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (
    status === 'blocked' ||
    status === 'suspended' ||
    status === 'inactive' ||
    !status
  ) {
    return <Navigate to="/assinatura" replace />;
  }

  return children;
};

export default SubscriptionGuard;
